import { isArray } from "lodash"
import { allTags } from "./constants"
import settings from "../settings"

export const urls = {
    contentPage: '/:slug(.*)/', 
    contentPages: '/pages/:slug/',
    media: '/pages/media/',
    mediaPage: '/pages/media/:slug/',
    create: '/section-modder/create/',
    details: '/:modId/',
    edit: '/:modId/edit/',
    errorNotFound: '/error-not-found/',
    landing: '/',
    modderSection: '/section-modder/',
    news: '/news/',
    info: '/info/',
    search: '/search/',
    subscriptions: '/followed-mods/',
    eula: '/pages/eula/',
    termsofuse: '/pages/terms-of-use/',
    problemInfo: '/support/', /* '/problem/' */
    problemMyTickets: '/support/my-tickets/',
    problemMyTicketsView: '/support/my-tickets/:slug/',
    modsRules: '/rules/',
    signin: '/signin/',
    signup: '/signup/',
    logout: '/signout/', /* logout: '/logout/', */

    adminSection: '/admin-panel/',
    moderatorSection: '/admin-panel/mods/', /* /moderator-panel/ */
    supportSection: '/admin-panel/support/',
    supportSectionTicketView: '/admin-panel/support/:slug/',
    commentsSection: '/admin-panel/comments/',
    usersSection: '/admin-panel/users/',

    review: '/:modId/review/',

    downloadPage: '/download/',

    prolongate: '/prolongate/',
    wot: 'https://worldoftanks.eu/',
    tanki: 'https://tanki.su',
    //media: '/media/',
}

export const getEula = (language) => language ? `/pages/eula_${language}` : `/pages/eula/`
export const getTermsOfUse = (language) => language ? `/pages/terms-of-use_${language}` : `/pages/terms-of-use/`
export const getTermsOfUsePortal = (language) => language ? `/pages/terms-of-use-portal_${language}` : `/pages/terms-of-use-portal`

export const getDetailsUrl = (modId) => urls.details.replace(/:modId/g, modId)
export const getEditUrl = (modId) => urls.edit.replace(/:modId/g, modId)
export const getReviewUrl = (modId) => urls.review.replace(/:modId/g, modId)

export const getMediaUrl = (media) => urls.mediaPage.replace(/:slug/g, media)

const lastUrler = document.location.href

export const footerLinks = {
    eula: {
        href: urls.eula, 
        isExternal: false, 
        title: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0441\u0430\u0439\u0442\u0430"
    }, 
    termsofuse: {
        href: urls.termsofuse, 
        isExternal: false, 
        title: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043C\u043E\u0434\u043E\u0432"
    }, 
    problemInfo: {
        href: urls.problemInfo, 
        isExternal: false, 
        title: "\u0426\u0435\u043D\u0442\u0440 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438"
    }, 
    tanki: {
        href: urls.tanki, 
        isExternal: true, 
        title: "\u041E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0430\u0439\u0442 \u0438\u0433\u0440\u044B \u041C\u0438\u0440 \u0422\u0430\u043D\u043A\u043E\u0432"
    }
}


export const pushHistoryWithLanding = (history) => {
    history.push({
        pathname: urls.landing,
        search: '',
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushHistoryWithTags = (history, tagId) => {
    let tagName
    if (!isArray(tagId)) {
        tagName = allTags.find(item => item.id === tagId).caption
    } else if (isArray(tagId) && tagId.length === 1) {
        tagName = allTags.find(item => item.id === tagId[0]).caption
    }

    history.push({
        pathname: urls.search,
        search: `?tags=${tagId}`,
        state: { tagName, lastUrler },
    },
    {
        tagName,
        lastUrler
    });
    history.go() // я добавил
    //return redirect(urls.search+`?tags=${tagId}`)
}

export const pushHistoryWithOwner = (history, ownerId, ownerName) => {
    history.push({
        pathname: urls.search,
        search: `?owner=${ownerId}`,
        state: { ownerName, lastUrler },
    },
    {
        ownerName,
        lastUrler
    })
    history.go() // я добавил
}

export const pushHistoryWithPage = (history, url, search, backPage) => {
    history.push({
        pathname: url,
        search: search,
        state: { backPage, lastUrler },
    },
    {
        backPage,
        lastUrler
    })
    history.go() // я добавил
}

export const pushHistoryWithDetails = (history, modId) => {
    history.push({
        pathname: urls.details.replace(/:modId/g, modId),
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushHistoryWithReview = (history, modId) => {
    history.push({
        pathname: urls.review.replace(/:modId/g, modId),
        state: lastUrler,
    },
    {
        lastUrler,
    }
    )
    history.go() // я добавил
}

export const pushHistoryWithCreate = (history) => {
    history.push({
        pathname: urls.create,
        search: '',
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushHistoryWithErrorNotFound = (history) => {
    history.replace({
        pathname: urls.errorNotFound,
        search: '',
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushHistoryWithModderSection = (history) => {
    history.replace({
        pathname: urls.modderSection,
        search: '',
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushHistoryWithAdminSection = (history, slug) => {
    if (slug) {
        history.replace({
            pathname: urls.adminSection+urls.contentPage.replace(`/:slug(.*)`, slug),
            search: '',
            state: lastUrler,
        }, { lastUrler })
    } else {
        history.replace({
            pathname: urls.adminSection,
            search: '',
            state: lastUrler,
        }, { lastUrler })
    }
    history.go() // я добавил
}

export const pushHistoryWithSupportSection = (history, slug) => {
    if (slug) {
        history.replace({
            pathname: urls.supportSectionTicketView.replace(/:slug/g, slug),
            search: '',
            state: {lastUrler, slug},
        }, { 
            lastUrler, 
            slug 
        })
    } else {
        history.replace({
            pathname: urls.supportSection,
            search: '',
            state: lastUrler,
        }, { lastUrler })
    }
    history.go() // я добавил
}

export const pushHistoryWithSupportMyTickets = (history, slug) => {
    if (slug) {
        history.replace({
            pathname: urls.problemMyTicketsView.replace(/:slug/g, slug),
            search: '',
            state: {lastUrler, slug},
        }, { 
            lastUrler, 
            slug 
        })
    } else {
        history.replace({
            pathname: urls.problemMyTickets,
            search: '',
            state: lastUrler,
        }, { lastUrler })
    }
    history.go() // я добавил
}

export const pushHistoryWithSignIn = (history) => {
    history.push({
        pathname: urls.signin,
        search: '',
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushHistoryWithSignUp = (history, key) => {
    history.push({
        pathname: urls.signup+`?key=%2Freg%2F${key}%2F`,
        search: '',
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushProlongateWithData = (history, rawData) => {
    history.replace({
        pathname: urls.prolongate,
        search: '?spa_id='+rawData.spaId+'&spa_username='+rawData.spaUsername+'&access_token='+rawData.access_token+'&expires='+rawData.expires,
        state: lastUrler,
    }, { lastUrler })
    history.go() // я добавил
}

export const pushHistoryWithTitle = (history, searchTitle) => {
    history.push({
        pathname: urls.search,
        search: `?title=${searchTitle}`,
        state: { searchTitle, lastUrler },
    },
    {
        searchTitle,
        lastUrler
    })
    history.go() // я добавил
}

export const pushHistoryWithDownload = (history, downloadUrls) => {
    history.push({
        pathname: urls.downloadPage,
        search: ``,
        state: { downloadUrls, lastUrler },
    },
    {
        downloadUrls,
        lastUrler
    })
    history.go() // я добавил
}

export const pushHistoryWithPages = (history, slug) => {
    history.push({
        pathname: urls.contentPages.replace(/:slug/g, slug),
        search: ``,
        state: { slug, lastUrler },
    },
    {
        slug,
        lastUrler
    })
    history.go() // я добавил
}

export const pushHistoryWithMediaPage = (history, slug) => {
    history.push({
        pathname: urls.mediaPage.replace(/:slug/g, slug),
        search: ``,
        state: { slug, lastUrler },
    },
    {
        slug,
        lastUrler
    })
    history.go() // я добавил
}


export class BaseUrlHandler {
    constructor(location, basename) {
        this.baseUrl = location.hostname === 'localhost' ? `https://tankimods.net${basename}` : `${location.protocol}//${location.hostname}${basename}`
        this.baseUrlAtTheBeginningRe = new RegExp(`^${this.baseUrl}`)
    }

    startsWithBaseUrl = (url) => {
        return url.startsWith(this.baseUrl)
    }

    stripBaseUrl = (url) => {
        return url.replace(this.baseUrlAtTheBeginningRe, '/')
    }
}

const urlHandler = new BaseUrlHandler(window.location, settings.basename) // BaseUrlHandler(location, settings.basename)
export const startsWithBaseUrl = urlHandler.startsWithBaseUrl
export const stripBaseUrl = urlHandler.stripBaseUrl


export const getPrivacyPolicyUrlByRealm = (realm) => {
    const mapping = {
        eu: 'http://legal.eu.wargaming.net/en/privacy-policy/',
        //us: 'http://legal.na.wargaming.net/en/privacy-policy/',
        ru: 'https://legal.lesta.ru/privacy-policy/', //'http://legal.ru.wargaming.net/ru/privacy-policy/',
        //sg: 'http://legal.asia.wargaming.net/en/privacy-policy/',
    }
    return mapping[realm] || '#'
}